import { render, staticRenderFns } from "./StepProcess.vue?vue&type=template&id=5a145c60&scoped=true"
import script from "./StepProcess.vue?vue&type=script&lang=js"
export * from "./StepProcess.vue?vue&type=script&lang=js"
import style0 from "./StepProcess.vue?vue&type=style&index=0&id=5a145c60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a145c60",
  null
  
)

export default component.exports